import React from 'react';
import PropTypes from 'prop-types';
import FormContainer from '../Forms/FormContainer';
import NeuroMessage from '../NeuroMessage';
import { ContactMeScreens as Screens, useDispatch } from '../../state/index';
import FormInput from '../Forms/FormInput';
import {formatPhoneNumberField} from '../../utils/helpers/formatHelper';
import { sendToLeadProcessor } from '../../state/ContactMe/ContactMeActions.mjs';

const ContactForm = ({
  children,
  useAppointmentFlow,
  onContactFormSubmit,
  onComplete,
  changeScreen,
  fields,
  fieldsForAnswerService,
  useBusinessFields,
  leadProcessor,
  cognitoConfig
}) => {
  const formId = 'contactMeForm';
  const dispatch = useDispatch();

  const formSubmitted = (state) => {
    const lead = { ...state };
    lead.phone = formatPhoneNumberField(lead.phone);

    onContactFormSubmit(lead, fieldsForAnswerService);
    sendToLeadProcessor(cognitoConfig, leadProcessor, lead).then(e => {
      e(dispatch);
    });

    if (!useAppointmentFlow) {
      onComplete({ type: 'contact', lead });
    } else {
      changeScreen(Screens.APPT_LOCATION);
    }
  };

  const getDefaultFields = () => useBusinessFields ? defaultBusinessFields : defaultConsumerFields;

  const renderedFields = (fields || getDefaultFields()).map( (fieldProps, index) =>
    <FormInput formId={ formId } key={index} { ...fieldProps }/>
  );

  return (
    <FormContainer className="contactMe__form" onSubmit={formSubmitted} formId={formId} renderDefaultSubmit={true}>
      { children }
      <div className="form-body">{ renderedFields }</div>
      <NeuroMessage id="contactMe.disclosure" shouldHideIfNotFound={true} />
    </FormContainer>
  );
};

ContactForm.propTypes = {
  contactLead: PropTypes.object,
  fields: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    required: PropTypes.bool,
    isEmail: PropTypes.bool,
    isPhoneNumber: PropTypes.bool
  })),
  schema: PropTypes.object,
  useAppointmentFlow: PropTypes.bool,
  useBusinessFields: PropTypes.bool,
  onContactFormSubmit: PropTypes.func,
  contactMeScreenChanged: PropTypes.func,
  children: PropTypes.any,
  shouldValidateOnChange: PropTypes.any,
  shouldValidateOnBlur: PropTypes.any,
  isProcessing: PropTypes.any,
  onComplete: PropTypes.any,
  validators: PropTypes.any,
  changeScreen: PropTypes.any,
  fieldsForAnswerService: PropTypes.any,
  leadProcessor: PropTypes.any,
  cognitoConfig: PropTypes.any
};

const contactFormCommonFields = {
  firstName: {
    name: 'firstName',
    type: 'text',
    required: true
  },
  lastName: {
    name: 'lastName',
    type: 'text',
    required: true
  },
  emailAddress: {
    name: 'email',
    type: 'email',
    required: true,
    isEmail: true
  },
  phoneNumber: {
    name: 'phone',
    type: 'text',
    isPhoneNumber: true
  },
  customerId: {
    name: 'customerId',
    type: 'text'
  },
  businessName: {
    name: 'businessName',
    type: 'text',
    isRequired: true
  }
};

const defaultConsumerFields = [
  contactFormCommonFields.firstName,
  contactFormCommonFields.lastName,
  contactFormCommonFields.emailAddress,
  contactFormCommonFields.phoneNumber
];

const defaultBusinessFields = [
  contactFormCommonFields.businessName,
  ...defaultConsumerFields
];

export default ContactForm;
export {
  contactFormCommonFields,
  defaultBusinessFields,
  defaultConsumerFields
};
